export default {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center"
};